import { PropsWithChildren } from 'react'

interface BaseHeaderProps {
  title: string
  className?: string
}
export function BaseHeader({
  title,
  children,
  className,
}: PropsWithChildren<BaseHeaderProps>) {
  return (
    <div className={`py-2 ${className}`}>
      <h1 className="text-2xl font-bold text-white">{title}</h1>
      {children}
    </div>
  )
}
